import xior, {type XiorRequestConfig, type XiorResponse} from 'xior';
import addCsrfRetryInterceptor from './csrfRetryInterceptor';

type Method =
  | 'get' | 'GET'
  | 'delete' | 'DELETE'
  | 'head' | 'HEAD'
  | 'options' | 'OPTIONS'
  | 'post' | 'POST'
  | 'put' | 'PUT'
  | 'patch' | 'PATCH'
  | 'purge' | 'PURGE'
  | 'link' | 'LINK'
  | 'unlink' | 'UNLINK';

const httpClient = xior.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

addCsrfRetryInterceptor(httpClient);


interface iHttpRequest {
  (url: string, config?: XiorRequestConfig): Promise<XiorResponse>;
  get: typeof httpClient.get;
  post: typeof httpClient.post;
  put: typeof httpClient.put;
  delete: typeof httpClient.delete;
  head: typeof httpClient.head;
}
const httpRequest: iHttpRequest = wrapper as iHttpRequest;
httpRequest.get = httpClient.get.bind(httpClient);
httpRequest.post = httpClient.post.bind(httpClient);
httpRequest.put = httpClient.put.bind(httpClient);
httpRequest.delete = httpClient.delete.bind(httpClient);
httpRequest.head = httpClient.head.bind(httpClient);

function wrapper(url: string, config?: XiorRequestConfig)  {
  const method = config?.method || 'GET';

  switch (method) {
    case 'GET':
    case 'get':
      return httpClient.get(url, config);
    case 'POST':
    case 'post':
      return httpClient.post(url, config.data, config);
    case 'PUT':
    case 'put':
      return httpClient.put(url, config.data, config);
    case 'DELETE':
    case 'delete':
      return httpClient.delete(url, config);
    case 'HEAD':
    case 'head':
      return httpClient.head(url, config);
    case 'OPTIONS':
    case 'options':
      return httpClient.options(url, config);
    case 'PATCH':
    case 'patch':
      return httpClient.patch(url, config);
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
}

export default httpRequest;
export {Method}
